<div class="modal" cdkScrollable data-cy="project-modal">
  <header class="modal__header">
    <h2 class="modal__header__title" data-cy="modal-title">
      {{ actionLabel | translate }}
    </h2>
    <button class="modal__header__close" (click)="closeModal($event)">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <ng-container *ngIf="!isEmployee && !editMode">
    <div class="flex-row">
      <span class="tab" (click)="changeTab(false)" [class.tab-active]="!isUserAccess">{{ mainTabTitle | translate }}</span>
      <span class="tab" (click)="changeTab(true)" translate [class.tab-active]="isUserAccess">Employees Access</span>
    </div>
  </ng-container>

  <div class="modal__content create-container" [class.show-scheduler]="showScheduler">
    <ng-container *ngIf="!(projectItem.loading$ | async)?.length">
      <loader [loading]="projectItem.loading$"></loader>
    </ng-container>

    <div *ngIf="projectItem.data.hasOwnProperty('id') || !editMode" class="flex-row" style="flex: 1 0 auto">
      <ng-container class="form__container">
        <form class="create-container__form" [class.w-100]="isEmployee || !showScheduler" [formGroup]="formGroup">
          <div [hidden]="isUserAccess">
            <ng-container *ngIf="isSubproject">
              <div class="controls-row">
                <div appFormControlError="parent_id" class="control-container form-group py-0">
                  <div class="control-container__label">
                    <span translate>Main project</span>
                    <span class="control-container__required">*</span>
                  </div>

                  <app-select
                    valueKey="id"
                    displayKey="name"
                    formControlName="parent_id"
                    [disabled]="editMode"
                    [placeholder]="'Search project' | translate"
                    [withNone]="true"
                    [hasBackdrop]="true"
                    [model]="mainProjectModel"
                    [collection]="projectsCollection"
                    [optionList]="projectsCollection.items"
                    (refreshCallback)="getProjectsList($event)"
                    (selectedValue)="selectedMainProject($event)"
                    data-cy="Main project select">
                  </app-select>
                </div>
              </div>
            </ng-container>

            <div class="controls-row">
              <div appFormControlError="name" class="control-container form-group py-0">
                <div class="control-container__label">
                  <span translate>Project Name</span>
                  <span class="control-container__required">*</span>
                </div>

                <input
                  #projectNameInput
                  class="control-container__control"
                  type="text"
                  formControlName="name"
                  data-cy="project-name-input" />
              </div>

              <div appFormControlError="display_id" class="control-container form-group py-0">
                <div class="control-container__label" translate>Project ID</div>

                <ng-container *ngIf="!editMode">
                  <loader [small]="true" [loading]="getProjectIdRequest.loading$"></loader>
                  <loader [small]="true" [loading]="getSubProjectIdRequest.loading$"></loader>
                </ng-container>

                <input
                  class="control-container__control"
                  type="text"
                  formControlName="display_id"
                  data-cy="project-display-id-input" />
              </div>
            </div>

            <div class="controls-row" *ngIf="!isEmployee">
              <div class="control-container flex flex-col gap-[7px] form-group py-0">
                <div class="relative">
                  <google-places-autocomplete
                    [place]="projectItem?.data?.project_location"
                    data-cy="project-location-input"
                    (emitGoogleAutoComplete)="setGeoControlValue($event)"
                    (emitEnteredValue)="onAddressInputChange($event)"></google-places-autocomplete>
                </div>

                <button
                  *ngIf="displayGnrBnrButton"
                  (click)="initGnrBrnFields()"
                  class="action-btn flex items-center max-w-[155px] bg-[transparent] text-sunset-orange">
                  <i
                    class="icon icon-Plus_light_ico text-[8px] pl-[3.3px] pt-[3.2px] pr-[2.60px] pb-[2.90px] mr-[6px] text-sunset-orange border-solid border-[1px] border-gray-6 rounded-full"></i>
                  <span class="text-[12px] leading-[16px]">{{ 'Add Gnr and Bnr' | translate }}</span>
                </button>
              </div>
            </div>

            <div *ngIf="displayGnrBnrFields" class="controls-row gap-[20px] mb-[15px]">
              <div class="flex flex-col w-full">
                <div class="flex flex-col">
                  <span class="text-12 text-b2-dark-brick font-medium leading-[16px]"
                    >{{ 'Gårdsnummer' | translate }}
                    <a [href]="externalGnrBnrLink" target="_blank">
                      <i
                        class="icon icon-ExternalLink_ico text-[13px] ml-[3px] cursor-pointer"
                        matTooltip="{{ 'Look up Gnr and Bnr' | translate }}"></i>
                    </a>
                  </span>
                  <input
                    #gnrInput="ngModel"
                    appOnlyNumbers
                    class="control-container__control"
                    [class.!border-[#E44E4E]]="gnrInput.errors && (gnrInput.dirty || gnrInput.touched)"
                    type="number"
                    data-cy="coast-input"
                    name="gnr"
                    min="1"
                    max="999999"
                    [value]="gnr"
                    [(ngModel)]="gnr"
                    [ngModelOptions]="{ standalone: true }"
                    (input)="handleGnrBnr($event, LocationInfo.Gnr)" />
                </div>
                <div *ngIf="gnrInput.errors && (gnrInput.dirty || gnrInput.touched)" class="mt-[4px] text-12 flex">
                  <p class="text-error-red" *ngIf="gnrInput.errors.max">{{ 'Max value is' | translate }} 999999</p>
                </div>
              </div>

              <div class="flex flex-col w-full">
                <div class="flex flex-col">
                  <span class="text-12 text-b2-dark-brick font-medium leading-[16px]">{{ 'Bruksnummer' | translate }}</span>
                  <input
                    #bnrInput="ngModel"
                    appOnlyNumbers
                    class="control-container__control"
                    [class.!border-[#E44E4E]]="bnrInput.errors && (bnrInput.dirty || bnrInput.touched)"
                    type="number"
                    data-cy="coast-input"
                    name="bnr"
                    min="1"
                    max="999999"
                    [value]="bnr"
                    [(ngModel)]="bnr"
                    [ngModelOptions]="{ standalone: true }"
                    (input)="handleGnrBnr($event, LocationInfo.Bnr)" />
                </div>

                <div *ngIf="bnrInput.errors && (bnrInput.dirty || bnrInput.touched)" class="mt-[4px] text-12 flex">
                  <p class="text-error-red" *ngIf="bnrInput.errors.max">{{ 'Max value is' | translate }} 999999</p>
                </div>
              </div>
            </div>

            <div class="controls-row">
              <div appFormControlError="client_id" class="control-container form-group py-0 text-ellipsis">
                <div class="control-container__label">
                  <span translate>Client</span>
                  <span class="create-label" (click)="createClient()">
                    <i class="icon icon-Plus_ico icon-plus"></i>
                    <span translate>Create Client</span>
                  </span>
                </div>

                <app-select
                  valueKey="id"
                  fieldKey="id"
                  displayKey="name"
                  formControlName="client_id"
                  data-cy="project-client-searchSelect"
                  [placeholder]="'Search' | translate"
                  [withNone]="true"
                  [model]="clientModel"
                  [collection]="clientsCollection"
                  [optionList]="clientsCollection.items"
                  (refreshCallback)="getClientsList($event)"
                  (selectedValue)="formGroup.markAsDirty(); selectClient($event)">
                </app-select>
              </div>
            </div>

            <div class="controls-row">
              <div class="control-container">
                <div class="control-container__label" translate>Start date</div>

                <app-datepicker
                  data-cy="start-date-datepicker"
                  formControlName="start_date"
                  [date]="formGroup.get('start_date').value"
                  [isResetShowed]="true"
                  [resetControl]="formGroup.controls['start_date']"
                  [height]="'32px'"
                  (dateChanged)="setFromCalendarDate($event)">
                </app-datepicker>
              </div>

              <div class="control-container">
                <div class="control-container__label" translate>Completion date</div>

                <app-datepicker
                  data-cy="end-date-datepicker"
                  formControlName="end_date"
                  [date]="formGroup.get('end_date').value"
                  [isResetShowed]="true"
                  [resetControl]="formGroup.controls['end_date']"
                  [height]="'32px'">
                </app-datepicker>
              </div>
            </div>

            <div class="controls-row">
              <div class="control-container form-group p-0" appFormControlError="price">
                <div class="control-container__label">
                  <span translate>Cost</span>
                  <span
                    class="icon icon-Question_new_ico question_ico_position"
                    [matTooltip]="'If you have an estimated cost of your project, you can set it here.' | translate"></span>
                </div>

                <input
                  appOnlyNumbers
                  class="control-container__control"
                  type="number"
                  data-cy="coast-input"
                  formControlName="price" />
              </div>

              <div class="control-container">
                <div class="control-container__label">
                  <span translate>Estimated hours</span>
                  <span
                    class="icon-Question_new_ico question_ico_position"
                    [matTooltip]="
                      'Set estimated hours for your project. If the hours on the project exceed the estimate, the status will be set to &quot;Over budget&quot;'
                        | translate
                    "></span>
                </div>

                <input
                  appOnlyNumbers
                  class="control-container__control"
                  type="number"
                  data-cy="estimated-hours-input"
                  formControlName="estimated_time_minutes" />
              </div>
            </div>
            <div class="controls-row controls-row">
              <div class="control-container form-group p-0" appFormControlError="description">
                <div class="control-container__label" translate>Project description</div>
                <textarea
                  #textArea
                  (keydown)="handleTabulation($event)"
                  data-cy="description-textarea"
                  formControlName="description"></textarea>
              </div>
            </div>
          </div>

          <div class="user-access" [class.user-access--visible]="isUserAccess">
            <user-access-tab [form]="formGroup"></user-access-tab>
          </div>
        </form>
      </ng-container>

      <div class="schedule-wrapper" *ngIf="!isEmployee && showScheduler">
        <h3 class="sub-title">{{ 'Project Schedule' | translate }}</h3>

        <mittanbud-banner [view]="mittanbudEnum.FULL_VIEW"> </mittanbud-banner>

        <div class="scheduler-period-picker-wrapper">
          <div class="scheduler-period-picker">
            <scheduler-period-picker
              [fromDate]="filtersScheduler.get(filterTypesEnum.FromDate)"
              [toDate]="filtersScheduler.get(filterTypesEnum.ToDate)"
              [period]="filtersScheduler.get(filterTypesEnum.Period)"
              [filters]="filtersScheduler"
              [showPeriod]="false"
              (updatedFilters)="updateSelectedItems($event)">
            </scheduler-period-picker>
          </div>
        </div>

        <scheduler-calendar
          [hideActionBtns]="true"
          [canProjectBeCreatedOnCellClick]="false"
          [filters]="filtersScheduler"></scheduler-calendar>
      </div>
    </div>
  </div>

  <div class="modal__actions">
    <div class="btn-group row-flex row-flex--middle mx-0">
      <button class="btn btn__bordered mr-2 uppercase" data-cy="cancel-button" (click)="closeModal($event)">
        <span translate>Cancel</span>
      </button>

      <ng-container *ngIf="!editMode && data.showScheduleBtn && showScheduler">
        <btn-loader
          styleClasses="btn__primary btn__primary--black mr-2"
          [uppercase]="true"
          [withIcon]="true"
          [buttonLabel]="'Save and schedule' | translate"
          [iconPosition]="'after'"
          iconClass="icon-Question_ico pl-1 pt-025"
          [tooltipText]="
            'Press here to save your project and then continue to schedule work for the assigned employees right away.'
              | translate
          "
          [loading]="(projectItem.loadingCrud$ | async).creating || (projectItem.loadingCrud$ | async).updating"
          (applyAction)="submit(true)"></btn-loader>
      </ng-container>

      <btn-loader
        styleClasses="btn__primary"
        [uppercase]="true"
        [buttonLabel]="'Save' | translate"
        [loading]="(projectItem.loadingCrud$ | async).creating || (projectItem.loadingCrud$ | async).updating"
        (applyAction)="submit()"
        data-cy="Project Save Button"></btn-loader>
    </div>
  </div>
</div>
